/**
 * @generated SignedSource<<0fbecc621934db49a19fa4fbbc573de5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OccurrencesOrderBy = "event_name" | "feedback" | "recording_watch_progress" | "start_date" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationOccurrencesDatetimeFilter = "past" | "upcoming" | "%future added value";
export type CreateMemberOccurrencesCSVDataInput = {
  appId?: string | null;
  appIds?: ReadonlyArray<string> | null;
  datetimeFilter?: OrganizationOccurrencesDatetimeFilter | null;
  direction?: OrderDirection | null;
  excludeCommunityEvents?: boolean | null;
  inProductsViewerIsAdminOf?: boolean | null;
  includedProductIds?: ReadonlyArray<string> | null;
  memberHasAttended?: boolean | null;
  memberHasRSVP?: boolean | null;
  memberHasViewedRecording?: boolean | null;
  orderBy?: OccurrencesOrderBy | null;
  organizationMembershipId: string;
};
export type AdminMembersReportEventsTableExportCSVButtonMutation$variables = {
  input: CreateMemberOccurrencesCSVDataInput;
};
export type AdminMembersReportEventsTableExportCSVButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type AdminMembersReportEventsTableExportCSVButtonMutation = {
  response: AdminMembersReportEventsTableExportCSVButtonMutation$data;
  variables: AdminMembersReportEventsTableExportCSVButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMemberOccurrencesCSVDataResponse",
    "kind": "LinkedField",
    "name": "createMemberOccurrencesCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportEventsTableExportCSVButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportEventsTableExportCSVButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed74b25c50a2d418d413eb58787e1de9",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportEventsTableExportCSVButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminMembersReportEventsTableExportCSVButtonMutation(\n  $input: CreateMemberOccurrencesCSVDataInput!\n) {\n  response: createMemberOccurrencesCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "780bddc1aaaf565c11bb0d641f04dc56";

export default node;
